import parseJSON from '../../../common/utils/parseJSON';

/**
 * Orders comments by timestamps.
 * @param {Object} userAssignedColors
 * @param {Object} comments
 * @param {string} clipId
 *
 * @return {Object}
 */
function orderByTimestamp(
userAssignedColors, comments, clipId)
{
  return Array.
  from(comments.values()).
  reduce((newComments, comment) => {
    const {
      timestamp,
      xPercent,
      yPercent,
      regionWidthPercent,
      regionHeightPercent,
      assetId,
      clipId: commentClipId,
      clipCommentTime,
      isAddedByCommentForm = false,
      isRejected = false
    } = comment.metadata ? parseJSON(comment.metadata) : {};

    const { createdByUser: { userId } } = comment;

    // If there is a clipId in the metadata and it does not match the selected clip, remove the comment.
    if (clipId && commentClipId && commentClipId !== clipId) {return newComments;}

    const isValid = !Number.isNaN(Number(timestamp)) &&
    !Number.isNaN(Number(xPercent)) &&
    !Number.isNaN(Number(yPercent));

    if (!isValid) {return newComments;}

    const newComment = {
      timestamp,
      xPercent,
      yPercent,
      regionWidthPercent,
      regionHeightPercent,
      isAddedByCommentForm,
      isRejected,
      colour: userAssignedColors[userId],
      ...(commentClipId ?
      {
        clipId: commentClipId,
        clipCommentTime
      } :
      { assetId }),
      ...comment
    };

    // Collect in creation (source Map) order; the timeline sort below reorders
    // them and numbering is applied afterwards.
    newComments.push(newComment);

    return newComments;

  }, []).
  // Sort by the comment's video timestamp FIRST, then number by that position,
  // so the earliest point in the video is always #1 and badges read in timeline
  // order. Adding an earlier comment renumbers later ones — the expected
  // behaviour for timeline review. Array.prototype.sort is stable, so comments
  // sharing a timestamp keep their creation order. See docs/adr/0006.
  sort((a, b) => Number(a.timestamp) - Number(b.timestamp)).
  map((comment, index) => ({ ...comment, number: index + 1 }));
}

export default orderByTimestamp;